import { Routes, Route } from 'react-router-dom';

import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { CreateCampaignPage } from './pages/CreateCampaignPage';
import { EditCampaignPage } from './pages/EditCampaignPage';
import { CampaignDetailPage } from './pages/CampaignDetailPage';
import { MarketplacePage } from './pages/MarketplacePage';
import { AdminPage } from './pages/AdminPage';
import { ShareRedirectPage } from './pages/ShareRedirectPage';
import { ProfilePage } from './pages/ProfilePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { AboutPage } from './pages/AboutPage';
import { FaqPage } from './pages/FaqPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/marketplace" element={<Layout><MarketplacePage /></Layout>} />
      <Route path="/terminos-y-condiciones" element={<Layout><TermsPage /></Layout>} />
      <Route path="/politica-de-privacidad" element={<Layout><PrivacyPage /></Layout>} />
      <Route path="/acerca-de" element={<Layout><AboutPage /></Layout>} />
      <Route path="/faq" element={<Layout><FaqPage /></Layout>} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/campaigns/create" element={<ProtectedRoute><CreateCampaignPage /></ProtectedRoute>} />
      <Route path="/campaigns/:id/edit" element={<ProtectedRoute><EditCampaignPage /></ProtectedRoute>} />
      <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/api/share/:shortId" element={<ShareRedirectPage />} />
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
      <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
    </Routes>
  );
}

export default App;